<!-- <p>risk-bar-graph works!</p> -->
<div class="demo-chart-wrapper">
  <div
    #echartsElement
    echarts
    [options]="chartOption"
    [ngStyle]="height ? { height: height } : {}"
    class="demo-chart"
  ></div>
</div>
